import React from 'react';
import {ThumbnailImage} from '@wix/wix-ui-tpa/cssVars';
import {GiftSmall} from '@wix/wix-ui-icons-common/on-stage';
import {classes} from './RecommendationImage.st.css';
import {PurchaseRecommendationModel} from '../../../../domain/models/PurchaseRecommendation.model';

export enum RecommendationImageDataHook {
  image = 'RecommendationImage.image',
  placeholder = 'RecommendationImage.placeholder',
}

export const LARGE_IMAGE_SIZE = 160;
export const SMALL_IMAGE_SIZE = 120;

const PLACEHOLDER_ICON_SIZE = '50';

export const RecommendationImage = ({
  recommendation,
  size,
}: {
  recommendation: PurchaseRecommendationModel;
  size: number;
}) => {
  if (!recommendation.image) {
    return (
      <div
        data-hook={RecommendationImageDataHook.placeholder}
        className={classes.defaultImage}
        style={{width: size, height: size}}>
        <GiftSmall size={PLACEHOLDER_ICON_SIZE} />
      </div>
    );
  }

  return (
    <ThumbnailImage
      src={recommendation.image.id ?? recommendation.image.url}
      width={size}
      height={size}
      alt={recommendation.image.altText ?? recommendation.displayName}
      data-hook={RecommendationImageDataHook.image}
      aria-hidden={false}
    />
  );
};
